import apolloClient from '../../../core/backendClient/apolloClient';
import Schemas from './graphql';

/**
 * @param {Client} client
 * @returns {Promise<string | null>}
 */
async function getDashData({ storeId, offset, limit }) {
  const res = await apolloClient.mutate({
    mutation: Schemas.GET_DASH_DATA,
    variables: { storeId, offset, limit },
  });
  if (res.data.getDashboardData.code === 200) {
    return res.data.getDashboardData.data;
  }
  return null;
}

export default {
  getDashData,
};
